import ajax from '../ajax'
//模型图片列表
export function ModeImgApi(params) {
    return ajax({
        method:'get',
        url: 'v2/model/index',
        params
    })
}
//模型图片移动
export function changeModeImgApi(data) {
    return ajax({
        method:'post',
        url: 'v2/model/changeProcess',
        data
    })
}

//模型获取标签数据
export function getModelLabelApi(params) {
    return ajax({
        method:'GET',
        url: 'v2/model/tag',
        params
    })
}
//模型获取图片弹窗标签(弹窗)
export function getModelImgLabelApi(data) {
    return ajax({
        method:'POST',
        url: '/v2/model/taglist',
        data
    })
}
//模型贴标签（弹窗 空格）
export function stickLabelApi(data) {
    return ajax({
        method:'POST',
        url: '/v2/model/tagsave',
        data
    })
}
//模型贴标签（弹窗 右键）
export function rightStickLabelApi(data) {
    return ajax({
        method:'POST',
        url: '/v2/model/tagModel',
        data
    })
}
// 模型单个标签的是否情况(标签操作)
export function singleLabelApi(data) {
    return ajax({
        method:'POST',
        url: 'v2/model/havetag',
        data
    })
}
// 模型键盘1 or 2 事件（标签操作贴标签）
export function fingerboardNumApi(data) {
    return ajax({
        method:'POST',
        url: 'v2/model/onetag',
        headers: {
            'Content-Type': 'multipart/form-data'
          },
        data:data
    })
}
//模型改变图片状态
export function changeImgApi(data) {
    return ajax({
        method:'POST',
        url: '/v2/model/changeProcess',
        data
    })
}
//diy模型自定义标签获取
export function getDiyLabelApi(params) {
    return ajax({
        method:'get',
        url: 'v2/model/get',
        params
    })
}
//diy模型自定义标签添加
export function addDiyLabelApi(data) {
    return ajax({
        method:'post',
        url: 'v2/model/add ',
        data
    })
}
//diy模型自定义标签移出
export function removeDiyLabelApi(data) {
    return ajax({
        method:'post',
        url: 'v2/model/remove',
        data
    })
}
//diy模型自定义标签修改
export function rewriteDiyLabelApi(data) {
    return ajax({
        method:'post',
        url: 'v2/model/rewrite',
        data
    })
}
//排序方式
export function showApi(params) {
    return ajax({
        method:'get',
        url: 'v2/model/show',
        params
    })
}

// 列表修改
export function editListApi(data) {
    return ajax({
        method:'post',
        url: 'v2/user/edit',
        data
    })
}

// 价格修改修改
export function  PriceListApi(data) {
    return ajax({
        method:'post',
        url: 'v2/model/price',
        data
    })
}

//删除图片
export function deleteApi(data) {
    return ajax({
        method: 'POST',
        url: 'v2/model/delete',
        data: data
    })
}








//新增

export function modeltagApi(params) {
    return ajax({
        method: 'get',
        url: 'v2/admin/modeltag',
        params
    })
}


export function contentApi(params) {
    return ajax({
        method: 'get',
        url: 'v2/model/content',
        params
    })
}



// WEBPACK FOOTER //
// ./src/apis/mode/index.js